export default __webpack_public_path__ + "static/media/footer_icon.6f044634.svg";